function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "30",
  viewBox: "0 0 32 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.563 9h1.876a6.588 6.588 0 014.91 2.21 1 1 0 01-1.494 1.33 4.587 4.587 0 00-3.174-1.533L9.438 11H7.562a4.625 4.625 0 00-.211 9.245l.212.005h1.872a4.593 4.593 0 003.42-1.54 1 1 0 011.495 1.33 6.594 6.594 0 01-4.631 2.203l-.281.007H7.562A6.625 6.625 0 017.33 9.004L7.562 9zm16.875 0a6.625 6.625 0 01.232 13.246l-.233.004H22.56a6.59 6.59 0 01-4.91-2.21 1 1 0 111.495-1.33 4.59 4.59 0 003.174 1.533l.244.007h1.875a4.625 4.625 0 00.211-9.245L24.437 11h-1.873a4.586 4.586 0 00-3.42 1.54 1 1 0 01-1.494-1.33 6.587 6.587 0 014.631-2.204L22.563 9h1.875zm-.875 6.624a1 1 0 00-1-1H9.438l-.117.006a1 1 0 00.117 1.994h13.124l.117-.007a1 1 0 00.884-.993z",
  fill: "currentColor"
})));